<template>
  <div class="voucherpage order-wrapper order-content">
    <portal target-el="#filter">
      <Breadcrumb
        back="Invoice"
        title="Voucher Details"
        :loading="isLoading"/>
    </portal>
    <div v-if="isLoading">
      <Spinner/>
    </div>
    <div v-else class="order-list-wrapper no-wrapper-margin ptl-row">
      <div v-for="invoice in vouchers" :key="invoice.id">
        <div class="table-title">
          <h2>INVOICE # {{invoice.invoice_number}}</h2>
        </div>
        <InvoiceField :customFields="customFields" :invoice="invoice" />

        <div class="smheight">
          <div class="iftable">
            <div class="new">
              <div class="table">
                <Table :data="indentPayments(invoice.order_payments)" style="width: 100%">
                  <Table-Column fixed="left" label="INDENT ID" width="150">
                    <template slot-scope="indent">
                      <div class="temp-style">{{ indent.row.order_number }}</div>
                    </template>
                  </Table-Column>
                  <Table-Column
                    v-for="column in getColumns"
                    :key="column.id"
                    width="100"
                    prop="column.column"
                    :label="`${column.label}`">
                    <template slot-scope="payment">
                      <div class="table-td">
                        <Row
                          :column="column"
                          :rowIndex="payment.$index"
                          :payment="payment.row"
                          :invoiceStatus="invoice.status"
                          :isReadOnly="readonlyprop"/>
                      </div>
                    </template>
                  </Table-Column>
                  <Table-Column label="Documents" width="150">
                    <template slot-scope="document">
                      <div class="temp-style">
                        <span v-for="attach in document.row.attachments" :key="attach._id">
                          <a :href="attach.attachment_url" target="_blanks">Attachment</a>
                        </span>
                      </div>
                    </template>
                  </Table-Column>
                  <Table-Column fixed="right" label="Total" width="150">
                    <template slot-scope="invoice">
                      <div class="temp-style">
                        <Amount
                          :columnDetails="totalColumn"
                          :payment="invoice.row"
                          :invoiceStatus="invoice.status"
                          :isReadOnly="readonlyprop"/>
                      </div>
                    </template>
                  </Table-Column>
                </Table>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="total-section">
    <div class="row">
     <div class="col-lg-6 col-md-6">
      <div class="total-title">Total INDENTS: {{invoice.order_payments.length}}</div>
      <div class="total-title" v-if="invoice.invoice_revision.type">
        {{invoice.invoice_revision.type === 2 ? 'Debit' : 'Credit'}}
         Note : <span class="inr-style">INR </span>
         {{invoice.invoice_revision.amount}} ({{invoice.invoice_revision.reference_number}})
       </div>
     </div>
     <div class="col-lg-6 col-md-6">
      <div class="voucher-section">
       <div class="order-content-list">
         <span class="order-content-title">Payable</span>
         <br>
         <span class="order-content-number">
          <span class="inr-style">INR </span>
          {{$invoice.invoiceTotal(indentPayments(invoice.order_payments), 'client')}}
        </span>
       </div>
      </div>
     </div>
    </div>
        </div>-->
      </div>
      <Footer v-if="!isLoading && vouchers.length" :invoices="vouchers" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { columns } from '@/constants/invoice';
import Breadcrumb from '../common/breadcrumb';
import Header from './header';
import Row from './row';
import Footer from '../common/voucher-footer';
import InvoiceField from '../common/invoiceFields';
import Amount from './amount';

export default {
  components: {
    Breadcrumb,
    Header,
    Row,
    Footer,
    Amount,
    InvoiceField,
  },
  data() {
    return {
      columns,
      totalColumn: { column: 'total_amount', compareBy: true },
      readonlyprop: true,
      customDetailsPop: false,
      cfields: {},
    };
  },
  computed: {
    ...mapState('invoice', [
      'isLoading',
      'vouchers',
      'extractFirstPayment',
      'customFields',
    ]),
    getColumns() {
      const getHeaders = [...this.columns];
      if (this.$hasFeature('detention_combine_days')) {
        getHeaders.splice(4, true); // Removed  unloading detention
        getHeaders[3].label = 'Detention'; // Rename loading detention as Detention
      }
      return getHeaders;
    },
  },
  beforeMount() {
    this.$store.dispatch('invoice/find', this.$route.params);
  },
  methods: {
    indentPayments(invoices) {
      return invoices
        .map(indent =>
          indent.charges.map(child =>
            Object.assign(
              {
                attachments: indent.attachments,
                order_number: indent.order_number,
                order_id: indent.order_id,
              },
              child,
            ),
          ),
        )
        .reduce((l, n) => l.concat(n), []);
    },
    columnHeaders(invoice) {
      const newObj = {};
      const firstPayment = invoice.order_payments.length
        ? invoice.order_payments[0]
        : {};
      if (firstPayment.paid_to === 1) {
        newObj.column = 'service_charge';
        newObj.label =
          firstPayment.same_state === 2 ? '(S/C) GST ' : 'GST (IGST)';
      } else {
        newObj.column = 'no_tax';
        newObj.label = 'GST (-RCM)';
      }
      const compareBy = invoice.status !== 1;
      return this.columns.map((col) => {
        const colObj = Object.assign({}, col);
        colObj.compareBy = ['no_tax', 'total_amount'].includes(col.column)
          ? true
          : compareBy;
        return col.column === 'no_tax' ? Object.assign(colObj, newObj) : colObj;
      });
    },
  },
};
</script>
<style lang='scss'>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';
.order-content {
    margin-bottom: 120px;
    padding-bottom: 30px;
    background: #fff;
    padding: 20px;
    box-shadow: 0 2px 4px 0 #ececec;
    height: 100vh;
    .table-row {
        //padding-left: 10px;
    }
    .order-list-wrapper {
        &.no-wrapper-margin {
            margin-top: 0;
        }
    }
}
.total-section {
    border-bottom: 1px solid #EFEFEF;
    border-left: 1px solid #EFEFEF;
    border-right: 1px solid #EFEFEF;
    padding: 7px 10px 2px;
    .total-title {
        color: #234357;
        text-transform: uppercase;
        font-family:$fontSemibold;
        font-size: 1.2rem;
        padding: 10px 0;
        float: left;
        margin-right: 30px;
    }
    .voucher-section {
        float: right;
        text-align: right;
        .order-content-title {
            color: #404040;
            font-size: 1rem;
            font-weight: normal;
            text-transform: uppercase;
        }
        .order-content-number {
            color: #234357;
            font-family:$fontSemibold;
            font-size: 1.4rem;
            line-height: 20px;
            .inr-style {
                font-weight: normal;
                padding: 0 10px 0 0;
                font-size: 1.2rem;
            }
        }
    }
}
.ptl-style {
    width: 100%;
    .table-row-style:nth-of-type(even) {
        background-color: #fff;
    }
}
.ptl-row {
    .total-section {
        margin-bottom: 20px;
    }
    .table-row {
        padding: 0;
        &-lite {
            padding: 0 0 !important;
            .table-td-lite {
                padding: 12px 0;
                div {
                    padding: 0 10px;
                }
            }
        }
    }
    .focus-contain-div {
        margin-top: 0 !important;
    }
}
</style>
